module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/exclusivenessIcon_UB.e2537d24.svg";